// assets/bookpacks-minimum-order.js
// Enforce school-specific minimum order *only on bookpack/booklist items*:
//
// - If ALL bookpacks in cart are St Bernardine's => $55 minimum
// - If ANY other school's bookpacks present     => $80 minimum
//
// Non-bookpack orders are not restricted.

(function() {
  const MIN_DEFAULT_BOOKLIST_TOTAL_CENTS = 8000; // $80.00
  const MIN_STB_BOOKLIST_TOTAL_CENTS     = 5500; // $55.00

  // Detect if a line item is one of our "booklist/bookpack" items
  function isBooklistItem(item) {
    if (!item) return false;

    const props = item.properties || {};
    const typeProp = String(props._bl_type || '').toLowerCase();

    // Primary signal: our own _bl_type from the booklist flow
    if (typeProp === 'booklist') return true;

    // Fallback heuristics (just in case something came in without properties)
    const productType = String(item.product_type || '').toLowerCase();
    const handle      = String(item.handle || '').toLowerCase();
    const title       = String(item.product_title || item.title || '').toLowerCase();

    if (productType === 'booklist item' || productType === 'booklist items') return true;
    if (handle.includes('booklist') || handle.includes('book-pack') || handle.includes('bookpack')) return true;
    if (title.includes('booklist') || title.includes('book pack') || title.includes('bookpack')) return true;

    return false;
  }

  // Detect if a booklist item belongs to St Bernardine's
  function isStBernardinesItem(item) {
    const props = item.properties || {};
    const slug  = String(props._bl_school_slug  || '').toLowerCase();
    const label = String(props._bl_school_label || '').toLowerCase();

    if (slug === 'stbernardinesschoolregentspark') return true;
    if (slug === 'stbernardinesregentspark') return true;
    if (label.includes('bernardine')) return true; // safe substring match

    return false;
  }

  // Decide if checkout is allowed based on bookpack subtotal only.
  async function cartAllowsCheckout() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) {
        console.warn('Could not load cart.js to enforce minimum; allowing checkout.');
        return true;
      }

      const cart = await res.json();
      if (!cart.items || !cart.items.length) return true;

      let hasBooklistItem       = false;
      let hasStBBooklistItem    = false;
      let hasNonStBBooklistItem = false;
      let booklistSubtotalCents = 0;

      cart.items.forEach((item) => {
        if (!isBooklistItem(item)) return;

        hasBooklistItem = true;

        // line_price is already price * quantity in cents
        const linePrice = typeof item.line_price === 'number'
          ? item.line_price
          : (item.price || 0) * (item.quantity || 0);

        booklistSubtotalCents += linePrice;

        if (isStBernardinesItem(item)) {
          hasStBBooklistItem = true;
        } else {
          hasNonStBBooklistItem = true;
        }
      });

      // If no bookpack/booklist items, no minimum restriction at all
      if (!hasBooklistItem) return true;

      // Choose the correct minimum:
      // - Any non-StB bookpacks present => $80
      // - Only StB bookpacks           => $55
      let minCents;
      if (hasNonStBBooklistItem) {
        minCents = MIN_DEFAULT_BOOKLIST_TOTAL_CENTS;
      } else if (hasStBBooklistItem) {
        minCents = MIN_STB_BOOKLIST_TOTAL_CENTS;
      } else {
        minCents = MIN_DEFAULT_BOOKLIST_TOTAL_CENTS; // fallback
      }

      if (booklistSubtotalCents >= minCents) return true;

      const booklistDollars = (booklistSubtotalCents / 100).toFixed(2);
      const minDollars      = (minCents / 100).toFixed(2);
      const remaining       = ((minCents - booklistSubtotalCents) / 100).toFixed(2);

      alert(
        'Minimum order for your school bookpacks is $' + minDollars + ' (bookpack items only).\n\n' +
        'Your current bookpack total is $' + booklistDollars + '.\n' +
        'Please add another $' + remaining + ' or more in bookpack items before checking out.'
      );

      return false;
    } catch (err) {
      console.error('Error enforcing bookpack minimum order:', err);
      // On error we *allow* checkout so customers are not blocked.
      return true;
    }
  }

  // Attach click handlers to all checkout buttons/links
  function bindBooklistMinHandlers() {
    const selectors = [
      'form[action="/cart"] [name="checkout"]',
      'button[name="checkout"]',
      'button[data-checkout]',
      'a[href*="/checkout"]'
    ];

    const buttons = document.querySelectorAll(selectors.join(','));
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      if (btn.dataset.booklistMinBound === 'true') return;
      btn.dataset.booklistMinBound = 'true';

      btn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        cartAllowsCheckout().then(function(ok) {
          if (!ok) return;

          const form = btn.closest('form');
          if (form) {
            if (!form.querySelector('[name="checkout"]')) {
              const hidden = document.createElement('input');
              hidden.type  = 'hidden';
              hidden.name  = 'checkout';
              hidden.value = 'Checkout';
              form.appendChild(hidden);
            }
            form.submit();
          } else if (btn.tagName === 'A' && btn.href) {
            window.location.href = btn.href;
          } else {
            window.location.href = '/checkout';
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindBooklistMinHandlers);
  document.addEventListener('shopify:section:load', bindBooklistMinHandlers);
  document.addEventListener('shopify:section:select', bindBooklistMinHandlers);
})();
